import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from '@type/user';
import { RootState } from '@store/reducer';

export interface UserState {
  user: IUser;
  isAuth: boolean;
  isLoading: boolean;
  showProfileSider: boolean;
}

export const initialState: UserState = {
  user: null,
  isAuth: false,
  isLoading: false,
  showProfileSider: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getUserInfoInitiate: (state) => {
      state.isLoading = true;
      state.user = null;
      state.isAuth = false;
    },
    getUserInfoSuccess: (state, { payload }: PayloadAction<IUser>) => {
      state.user = payload;
      state.isAuth = true;
      state.isLoading = false;
    },
    getUserInfoFaild: (state) => {
      state.user = null;
      state.isAuth = false;
      state.isLoading = false;
    },

    setShowProfileSider: (state, { payload }: PayloadAction<boolean>) => {
      state.showProfileSider = payload;
    },
  },
});

export const sliceActions = userSlice.actions;
export const userReducer = userSlice.reducer;
export const userSelector = (state: RootState) => state.user;
